import { connect } from 'react-redux';

import { userHasInstitutionLogin, userHasRegistration, isAnonShibbolethLogin, isAnonymousUser } from '../HeaderComponentSelectors';
import UnauthSiteNavigation from './UnauthSiteNavigation';

function mapStateToProps(state) {
  return {
    userHasInstitutionLogin: userHasInstitutionLogin(state),
    userHasRegistration: userHasRegistration(state),
    isAnonShibbolethLogin: isAnonShibbolethLogin(state),
    isAnonymousUser: isAnonymousUser(state),
  };
}

export default connect(mapStateToProps)(UnauthSiteNavigation);
